var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCredit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#C79400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13523_154060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.1389L15.7222 6.55558C15.6666 6.47224 15.5555 6.41669 15.4722 6.41669H8.49997C8.49997 6.41669 8.30553 6.44446 8.19442 6.63891C7.86108 7.19446 5.74997 10.3334 5.74997 10.3334L5.61108 10.5556L5.77775 10.75L11.4444 17.3611C11.5 17.4167 11.5278 17.4445 11.5833 17.4722C11.6666 17.5278 12 17.6111 12.1944 17.4722C12.25 17.4445 12.2778 17.3889 12.3333 17.3611L17.6666 11.8889C17.8055 11.7778 17.8055 11.5556 17.6666 11.4445C17.5555 11.3056 17.3611 11.3056 17.25 11.4445L12.6389 16.1945L14.6389 10.6945H17.9166C17.9444 10.6945 18.1666 10.6945 18.2222 10.6389L18.25 10.6111C18.4166 10.5278 18.4444 10.3334 18.3333 10.1389ZM15.5278 7.05558L14.2778 10H9.77775L8.66664 7.05558H15.5278ZM8.2222 7.69447L9.16664 10.0278H6.66664L8.2222 7.69447ZM6.52775 10.6389H9.33331L11.1389 16.0556L6.52775 10.6389ZM11.8889 16.4167L9.9722 10.6389H13.9722L11.8889 16.4167ZM14.9166 10.0278L15.8889 7.86113L17.4444 10.0556H14.9166V10.0278Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13523_154060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(5.33325 5.33334)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.acc4e7ad.svg";
export { ForwardRef as ReactComponent };